import { Component } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import axios from 'src/app/Service/axios';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';

declare let $: any;

@Component({
  selector: 'app-sms-modal',
  templateUrl: './sms-modal.component.html',
  styleUrls: ['./sms-modal.component.css'],
})
export class SmsModalComponent {
  smsForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private gurdService: GurdServiceService,
    private notify: NotificationService,
    private otherService: OtherService,
  ) {
    this.smsForm = this.fb.group({
      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      lststrUnitIDs: new FormControl('', Validators.required),
      strSMS: new FormControl('', Validators.required),
      bGPRS: new FormControl(true),
    });
  }

  get isGprs(): boolean {
    return !!this.smsForm.get('bGPRS')?.value;
  }

  setMode(useGprs: boolean): void {
    this.smsForm.get('bGPRS')?.setValue(useGprs);
  }

  open(unitIds: string[]): void {
    this.smsForm.patchValue({
      lststrUnitIDs: unitIds,
      strSMS: '',
      bGPRS: true,
    });
    $('#SmsModal').modal('show');
  }

  async send(): Promise<void> {
    if (this.smsForm.invalid)
      return this.notify.showError('متن پیامک را وارد کنید');

    this.otherService.Showspinner();
    const model = this.otherService.stringNumberToNumber(this.smsForm.value);
    const response = await axios.post(`SendSMS2MobilesSelected`, model);
    this.otherService.nonespinner();

    const res = JSON.parse(response.data.toString());
    if (res.iResult == 0) return this.notify.showError(res.strError);

    this.notify.showSuccess('پیامک با موفقیت ارسال شد');
    this.smsForm.patchValue({ lststrUnitIDs: '', strSMS: '', bGPRS: true });
    $('#SmsModal').modal('hide');
  }
}
